import axios, { AxiosPromise } from 'axios';

const stahnoutPdfApi = (id: string): AxiosPromise<{ redirect: string }> => {
    return axios({
        method: 'GET',
        url: `Akcionar/${id}/PreparePDF`
    });
};

export default stahnoutPdfApi;
